import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaBoxOpen, FaCheckCircle, FaStar, FaStoreSlash } from 'react-icons/fa';

function Comenzi() {
  const [comenzi, setComenzi] = useState([]);
  const [incarca, setIncarca] = useState(true);
  const navigate = useNavigate();

  const taburi = [
    { nume: 'Gestioneaza anunturile', link: '/anunturile-mele', activ: false },
    { nume: 'Comenzile mele', link: '/comenzi', activ: true },
    { nume: 'Mesaje', link: '/mesaje', activ: false },
    { nume: 'Favorite', link: '/favorite', activ: false },
    { nume: 'Alertele mele', link: '/alerte', activ: false },
    { nume: 'Detaliile mele', link: '/setari', activ: false }
  ];

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }
    incarcaComenzi(token);
  }, [navigate]);

  const incarcaComenzi = async (token) => {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/comenzi/mele', {
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      
      if (raspuns.ok) {
        setComenzi(date);
      } else {
        toast.error(date.mesaj || 'Eroare la incarcarea comenzilor');
      }
    } catch (err) {
      toast.error('Eroare de conexiune cu serverul');
    } finally {
      setIncarca(false);
    }
  };

  const formateazaData = (dataString) => {
    const d = new Date(dataString);
    return d.toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans">
      <div className="bg-white border-b border-gray-200 overflow-x-auto shadow-sm">
        <div className="max-w-7xl mx-auto px-4 flex min-w-max">
          {taburi.map((tab, index) => (
            <Link
              key={index}
              to={tab.link}
              className={`flex items-center gap-2 px-6 py-4 text-sm font-bold transition-all border-b-4 ${
                tab.activ 
                  ? 'border-blue-600 text-blue-700 bg-blue-50/50' 
                  : 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50'
              }`}
            >
              {tab.nume}
            </Link>
          ))}
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="mb-8">
          <h1 className="text-3xl font-black text-gray-900 tracking-tight flex items-center gap-3">
            <FaBoxOpen className="text-blue-600" />
            Istoric Achizitii
          </h1>
          <p className="text-gray-500 mt-2 font-medium">Urmareste toate produsele cumparate prin platforma Tranzitio.</p>
        </div>

        {incarca ? (
          <div className="flex justify-center items-center py-20">
            <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
          </div>
        ) : comenzi.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-16 text-center">
            <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <FaBoxOpen className="w-10 h-10 text-gray-300" />
            </div>
            <h2 className="text-2xl font-black text-gray-900 mb-2">Nu ai nicio comanda</h2>
            <p className="text-gray-500 font-medium mb-8">Inca nu ai cumparat niciun produs de pe platforma noastra.</p>
            <Link to="/" className="bg-blue-600 text-white font-bold px-8 py-3.5 rounded-xl hover:bg-blue-700 transition">
              Incepe cumparaturile
            </Link>
          </div>
        ) : (
          <div className="flex flex-col gap-6">
            {comenzi.map((comanda) => {
              const anuntExista = comanda.anunt !== null;
              let imagineAfisata = '';
              
              if (anuntExista) {
                if (Array.isArray(comanda.anunt.imagini) && comanda.anunt.imagini.length > 0) {
                  imagineAfisata = comanda.anunt.imagini[0];
                } else if (comanda.anunt.imagine) {
                  imagineAfisata = comanda.anunt.imagine;
                }
              }

              return (
                <div key={comanda._id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col md:flex-row transition hover:shadow-md">
                  
                  <div className="w-full md:w-48 h-48 md:h-auto bg-gray-50 shrink-0 border-b md:border-b-0 md:border-r border-gray-100 relative">
                    {anuntExista ? (
                      imagineAfisata ? (
                        <img src={imagineAfisata} alt={comanda.anunt.titlu} className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
                          <FaBoxOpen className="w-8 h-8 mb-2 opacity-30" />
                          <span className="text-xs font-bold">Fara poza</span>
                        </div>
                      )
                    ) : (
                      <div className="w-full h-full flex flex-col items-center justify-center text-gray-400 bg-gray-100">
                        <FaStoreSlash className="w-8 h-8 mb-2 opacity-50" />
                        <span className="text-xs font-bold text-center px-4">Anunt Sters de Vanzator</span>
                      </div>
                    )}
                  </div>

                  <div className="p-6 flex flex-col flex-grow">
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <span className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 text-xs font-bold px-2.5 py-1 rounded-md mb-3 border border-emerald-100">
                          <FaCheckCircle /> Comanda Finalizata
                        </span>
                        <h3 className="text-xl font-bold text-gray-900 leading-tight">
                          {anuntExista ? comanda.anunt.titlu : 'Produs indisponibil'}
                        </h3>
                      </div>
                      {anuntExista && (
                        <div className="text-right ml-4 shrink-0">
                          <span className="block text-2xl font-black text-blue-700 leading-none">
                            {comanda.anunt.pret} <span className="text-sm font-bold">{comanda.anunt.moneda || 'RON'}</span>
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="mt-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                      <div>
                        <p className="text-sm text-gray-500 mb-1">
                          Vanzator: <span className="font-bold text-gray-900">{comanda.vanzator ? comanda.vanzator.nume : 'Cont Sters'}</span>
                        </p>
                        <p className="text-sm text-gray-500 mb-1">
                          Data achizitiei: <span className="font-bold text-gray-900">{formateazaData(comanda.data)}</span>
                        </p>
                        {comanda.adresaLivrare && (
                          <div className="mt-3 bg-gray-50 rounded-xl p-3 border border-gray-100">
                            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Date livrare</p>
                            <p className="text-sm text-gray-700 font-medium">{comanda.numeDestinatarLivrare}</p>
                            <p className="text-sm text-gray-700">{comanda.telefonLivrare}</p>
                            <p className="text-sm text-gray-700">{comanda.adresaLivrare}</p>
                          </div>
                        )}
                        <p className="text-xs text-gray-400 font-mono mt-2">ID: {comanda._id}</p>
                      </div>

                      <div className="flex justify-end gap-3 mt-4 md:mt-0">
                        {anuntExista && (
                          <>
                            <Link
                              to={`/anunt/${comanda.anunt._id}`}
                              className="bg-amber-50 text-amber-700 border border-amber-200 font-bold px-4 py-2.5 rounded-xl hover:bg-amber-100 transition text-sm flex items-center gap-2"
                            >
                              <FaStar />
                              Lasa Recenzie
                            </Link>
                            <Link
                              to={`/anunt/${comanda.anunt._id}`}
                              className="bg-gray-100 text-gray-700 font-bold px-4 py-2.5 rounded-xl hover:bg-gray-200 transition text-sm"
                            >
                              Vezi Anuntul
                            </Link>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Comenzi;